module.exports = __webpack_public_path__ + "static/img/19.0beded8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcco/19.png
// module id = wIWh
// module chunks = 0